import { useState } from "react";
import { Handle, Position } from "reactflow";
import { RiUserSettingsFill } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import Input from "../../../utils/components/Input";

const AutoStepNode = ({
  translate,
  stepData,
  isEditing,
  isEndNode,
  onSerialAddClick,
  onFinishClick,
  onAutoStepClick,
  onChangeTitle,
  onActionClick,
  onRemoveClick,
}) => {
  const [showAddOptions, setShowAddOptions] = useState(false);
  return (
    <div>
      <Handle
        type="target"
        position={Position.Top}
        id={`TargetTop${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`SourceRight${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`SourceLeft${stepData.step_code}`}
      />
      <Handle
        type="target"
        position={Position.Right}
        id={`TargetRight${stepData.step_code}`}
      />
      <Handle
        type="target"
        position={Position.Left}
        id={`TargetLeft${stepData.step_code}`}
      />

      <div className="card shadow">
        {isEditing && (
          <span className="serial-add-node d-flex flex-row align-items-start justify-content-center">
            <span
              className="icon rounded-circle p-2 mt-1"
              onClick={() => setShowAddOptions(!showAddOptions)}
            >
              <AiOutlinePlus className="fs-5 text-white" />
            </span>
            {showAddOptions && (
              <div className="addOptions d-flex flex-column ms-3">
                <span
                  className="addSerialOption fs-4 fw-semibold text-orange mt-1"
                  onClick={() => {
                    setShowAddOptions(false);
                    onSerialAddClick();
                  }}
                >
                  {translate("design_approval_process.nodes.manual")}
                </span>
                <span
                  className="addAutoOption fs-4 fw-semibold text-orange my-2"
                  onClick={() => {
                    setShowAddOptions(false);
                    onAutoStepClick();
                  }}
                >
                  Automatic
                </span>
                {isEndNode && (
                  <span
                    className="addFinishOption fs-4 fw-semibold text-orange"
                    onClick={() => {
                      setShowAddOptions(false);
                      onFinishClick();
                    }}
                  >
                    {translate("design_approval_process.nodes.ending")}
                  </span>
                )}
              </div>
            )}
          </span>
        )}
        <div className="card-header d-flex flex-wrap align-items-center justify-content-between py-3">
          <div className="d-flex align-items-center">
            <RiUserSettingsFill className="fs-2 me-2" />
            {isEditing ? (
              <Input
                type="text"
                className="form-control"
                placeholder={translate(
                  "design_approval_process.nodes.enter-title"
                )}
                defaultValue={stepData.name || ""}
                onChange={onChangeTitle}
              />
            ) : (
              <p className="fs-5 mb-0 ms-2">{stepData.name}</p>
            )}
          </div>
          {isEditing && (
            <FiSettings
              className="fs-2 ml-2 cursor--pointer"
              onClick={onActionClick}
            />
          )}
        </div>
        <div className="card-body text-start">
          {stepData.settings.step_info.info_description}
        </div>
        <div className="card-footer d-flex align-items-center bg-white py-2 border-gray">
          {isEditing && (
            <MdOutlineClose
              className="fs-1 text-orange ml-2 ms-auto"
              onClick={onRemoveClick}
            />
          )}
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id={`SourceBottom${stepData.step_code}`}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`SourceLeft${stepData.step_code}`}
      />
    </div>
  );
};

export default AutoStepNode;
